import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IUserLoginResponse } from '../models';

const PrivateRoute = ({ children, ...rest }) => {
  const { access } = useSelector(
    (state: { authentication: IUserLoginResponse }) => state.authentication
  );
  return (
    <Route
      {...rest}
      render={({ location }) =>
        access ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
